import React from 'react';

import { connect } from 'react-redux/dist/react-redux.min.js';
import SharedModels from '../../../../../shared/sharedModels';
import { initialCardFetch } from '../../utils';
const ReduxStore = require('../../redux/reduxStore.jsx.js');

const ToastAlert = require('../../components/toastAlert');
import { SearchScreen } from './../searchScreen.jsx';
import AjaxFunctions from '../../ajaxFunctions';
import {Grid, Tabs} from '@material-ui/core';
import ListPane from './../listPane.js';

class ManiaAddExistingCard extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         isLoadingData: false,
         incubatorCardMap: new Map(),
         mapFetched: false,
      }
   }

   async componentDidMount() {
      let container = document.getElementById('maniaAddExistingDialogContent');
      container.onscroll = async () => {
         // Calculate percentage of page scrolled
         let { scrollTop, scrollHeight, clientHeight} = container;
         let scrollPercent = scrollTop / (scrollHeight - clientHeight);

         let x = 0;

         if(
            !this.state.isLoadingData
            && scrollPercent >= 0.75
         ) {
            await this.loadMoreCards();
         }
      };


      await this.getManiaItems();
      this.props.cardTypes && this.props.setFilterArray(this.props.cardTypes.map(x => x.value))
      await this.loadMoreCards();
   }

   async loadMoreCards() {
      this.setState({ isLoadingData: true });
      let lastDate = null;
      let list = this.props.cards;
      if (list.length > 0) {
         lastDate = list[list.length - 1].creationTime;
      }
      try {
         await initialCardFetch(lastDate, true)
      } catch(e) {
         console.log(e);
         this.setState({ isLoadingData: false });
      }
      this.setState({ isLoadingData: false });
   }

   /*
   loadMoreCards() {
      this.setState({ isLoadingData: true });
      let lastDate = null;
      initialCardFetch(lastDate, true).then(() => {
         this.setState({ isLoadingData: false })
      },(err) => {
         console.log(err);
         this.setState({ isLoadingData: false });
      });
   }

    */

   async getManiaItems() {
      const { portfolio, showAdded = false } = this.props;
      try {
         if (!showAdded) {
            let maniaAddedCards = await AjaxFunctions.getManiaMatchesByID(portfolio.id, portfolio.idManiaTournament);
            maniaAddedCards.filter(x => x.idRound === 1)
            let incubatorCardMap = new Map();
            maniaAddedCards.forEach(cur => { incubatorCardMap.set(cur.id,cur) });
            this.setState({ incubatorCardMap, mapFetched: true });
         }
      } catch (err) {
         ToastAlert.error("Error getting incubator cards");
      }
   }

   render() {
      const {
         getUpdatedPortfolioData,
         showAdded = false,
         addCardFunction,
         linkFunction,
         cardFilter,
         portfolio,
         cards,
         tab,
      } = this.props;
      const { mapFetched, incubatorCardMap } = this.state;

      let filteredCards = cardFilter ? cardFilter(cards) : cards;
      if (!mapFetched && !showAdded) {
         filteredCards = [];
      }

      return (
         <Grid container spacing={2} >
            <Grid className='left-bar' item lg={3}>
               <SearchScreen
                  lastFilterFunction={() => initialCardFetch('', false)}
                  setLastFilterFunction={func => this.setState({ lastFilterFunction: func })}
                  disableCardTypeFilter={Boolean(this.props.cardTypes)}
               />
            </Grid>
            <Grid item lg={9} >
               <ListPane
                  tab={tab}
                  cards={filteredCards}
                  idPortfolio={portfolio.id}
                  portfolioName={portfolio.name}
                  linkFunction={cardData => linkFunction(cardData)}
                  portfolioCardMap={incubatorCardMap}
                  addCardFunction={addCardFunction}
                  showAddButton={true}
                  getUpdatedPortfolioData={() => {
                     this.getManiaItems();
                     getUpdatedPortfolioData();
                  }}
               />
            </Grid>
         </Grid>
      );
   }
}

const mapAddCardStateToProps = state => {
   return {
      portfolio: new SharedModels.Incubator(state.PortfolioReducer.curPortfolio),
      cards: state.CardReducer.cardList,
   }
};

const mapCardTypeFilterBarDispatchToProps = (dispatch) => {
   return {
      clearFilter: () => {
         dispatch(ReduxStore.EditorFunctions.clearCardTypeFilter());
      },
      setFilterArray: (filterArray) => {
         dispatch(ReduxStore.EditorFunctions.setCardTypeFilterArray(filterArray));
         doFilterOperation();
      }
   }
};

async function doFilterOperation(){
   let cardTypeFilterArray = ReduxStore.store.getState().EditorReducer.cardTypeFilterArray;
   let filterObject = {};
   if(cardTypeFilterArray.length > 0){
      filterObject.cardTypes = cardTypeFilterArray.map(t => t.value);
   }
   let data = await AjaxFunctions.getFilteredCardData(filterObject);
   ReduxStore.appendCardData(data);
}

export default connect(
   mapAddCardStateToProps,
   mapCardTypeFilterBarDispatchToProps
)(ManiaAddExistingCard);
